import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { fetchFumigationCompaniesService } from "services/fetchFumigationCompanies.service";

// GET /fumigators -> server responds with { data: string[] } (company names)
export interface FumigationCompaniesResponse {
    data: string[];
}

/** Shared query key for fumigation company list cache */
export const FUMIGATION_COMPANIES_KEY = ['fumigationCompanies'] as const;

/**
 * Fetches the list of fumigation company names from the API.
 * Uses useQuery for proper caching and automatic refetching.
 */
const useFetchFumigationCompanies = () => {
    return useQuery<FumigationCompaniesResponse, AxiosError>(
        FUMIGATION_COMPANIES_KEY,
        fetchFumigationCompaniesService,
        {
            // Treat data as fresh for 5 minutes — multiple mounts won't re-fetch
            staleTime: 5 * 60 * 1000,
            // Keep unused cache entries for 10 minutes
            cacheTime: 10 * 60 * 1000,
            // Don't refetch on window focus since this is relatively static data
            refetchOnWindowFocus: false,
        }
    );
}

export default useFetchFumigationCompanies;
